<template>
  <div class="fixed bottom-60px flex left-1/2 transform !-translate-x-1/2 justify-center items-center">
    <div class="w-960px h-170px trajectory relative p-20px text-white">
      <div class="h-20px flex justify-between items-center">
        <div class="text-20px font-400">轨迹回放</div>
        <div
          class="flex items-center justify-center absolute single-close w-24px h-24px right-20px z-999 cursor-pointer rounded-[50%]"
          @click="closeTrajectory()">
          <span class="text-12px iconfont icon-line-close text-[#34b9f2]"></span>
        </div>
      </div>
      <div class="mt-10px h-50px">
        <div class="flex flex-row justify-between items-center text-14px h-20px text-[#feff00]">
          <span v-show="sliderBegin !== 0">
            {{
              dayjs((dayjs(sliderBegin).unix() + playProgress) * 1000).format('YYYY-MM-DD HH:mm:ss')
            }}
          </span>
          <span v-show="sliderEnd !== 0">{{ dayjs(sliderEnd).format('YYYY-MM-DD HH:mm:ss') }}</span>
        </div>
        <el-slider :style="{ '--width': sliderWidth }" v-model="playProgress" :disabled="loadSlider"
          @change="sliderChange" :min="0" :max="sliderMaxLength" :format-tooltip="formatSliderTooltip"
          :marks="sliderMarkerList"></el-slider>
      </div>
      <div class="mt-10px">
        <!-- 动画控制 -->
        <el-tooltip content="减速" placement="top" effect="dark">
          <span
            class="iconfont icon-bg-backward animate-control w-30px h-30px inline-flex justify-center items-center text-14px"
            @click="changeSpeed('minus')"></span>
        </el-tooltip>
        <el-tooltip content="播放" placement="top" effect="dark" v-if="!playStatus">
          <span @click="changeStatus(true)"
            class="iconfont icon-bg-play ml-10px animate-control w-30px h-30px inline-flex justify-center items-center text-14px"></span>
        </el-tooltip>
        <el-tooltip content="暂停" placement="top" effect="dark" v-if="playStatus">
          <span @click="changeStatus(false)"
            class="iconfont icon-bg-pause ml-10px animate-control w-30px h-30px inline-flex justify-center items-center text-14px"></span>
        </el-tooltip>
        <el-tooltip content="加速" placement="top" effect="dark">
          <span
            class="iconfont icon-bg-forward ml-10px animate-control w-30px h-30px inline-flex justify-center items-center text-14px"
            @click="changeSpeed('add')"></span>
        </el-tooltip>
        <!-- 切换视角 -->
        <el-select v-if="!removeVisualAngle" class="ml-10px visual_input w-140px" v-model="visualAngle" value-key
          placeholder="切换视角" popper-class="visualization-select-popper" filterable size="mini"
          :disabled="!changeVisualAngleAble" @change="changeVisualAngle">
          <el-option v-for="item in visualAngleList" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <!-- 播放速度 -->
        <el-select v-if="!removeSpeed" class="ml-10px visual_input w-80px" v-model="speed" size="mini" value-key
          placeholder="播放速度" clearable filterable :disabled="!changeSpeedAble"
          popper-class="visualization-select-popper" @change="changeSpeed">
          <el-option v-for="item in speedOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <template v-if="!removeQuery">
          <!-- 时间选择框 -->
          <el-date-picker class="ml-10px visual_input" v-model="dateList" type="datetimerange" size="mini"
            popper-class="visualization-picker-popper" range-separator="-" start-placeholder="开始时间"
            end-placeholder="结束时间" :disabled="!changeTimeAble" :picker-options="pickerOptions"
            @change="changeDateList"></el-date-picker>
          <!-- 查询-->
          <el-button type="primary" :loading="loadHistoryTrial" size="small" @click="getHistoryTrialData"
            :disabled="!changeTimeAble" class="ml-10px">查询</el-button>
        </template>
        <el-button v-if="!removeCancelFollow" type="primary" size="small" @click="toggleFollow"
          :disabled="cancelFollowAble" class="ml-10px cancelBtn">{{ isFollow ? '取消跟随' : '跟随' }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { PersonnelApi, BuildingApi, FloorApi, judgeTimeSpanData } from '@wiz-api/personnel-position'
import dayjs from 'dayjs'
import buildingList from '../../../assets/js/componentMethods/buildingList'
import { ClipApi, CompositeStateApi } from '@wiz-api/scene-management'
import cloudRender from '../../../assets/js/model/index'
import { PersonnelLocationApi } from '@wiz-api/huizhou2'
import { isEmpty, flatten, map, cloneDeep, filter, some, isNil, throttle, find } from 'lodash'
import TableButtonGroup from '@/components/cockpit/TableButtonGroup'

const buildingApi = new BuildingApi()
const floorApi = new FloorApi()
const clipApi = new ClipApi()
const compositeStateApi = new CompositeStateApi()
const personnelLocationApi = new PersonnelLocationApi()

const personnelApi = new PersonnelApi()
export default {
  name: 'trajectory',
  components: {
    TableButtonGroup,
  },
  props: {
    /** 人员id */
    personnelId: {
      type: String,
      default: '',
    },
    /** 人员标签的code */
    tagCode: {
      type: String,
      default: '',
    },
    /** 云渲染实例 */
    cloudRender: {
      type: Object,
      default: () => { },
    },
    /** ModelId */
    modelId: {
      type: String,
      defalut: '',
    },
    /** 基础数据  */
    defaultData: {
      type: Object,
      default() {
        return {
          /** 时间搜索 */
          dateList: [],
          /** 播放速度 */
          speed: 0,
          /** 视角选择 */
          visualAngle: 2,
          /** 忽略空数据粒度 */
          ignoreNull: 500,
        }
      },
    },
    /** 是否允许切换时间 */
    changeTimeAble: {
      type: Boolean,
      default: true,
    },
    /** 是否允许切换速度 */
    changeSpeedAble: {
      type: Boolean,
      default: true,
    },
    /** 是否禁用取消跟随 */
    cancelFollowAble: {
      type: Boolean,
      default: true,
    },
    /** 是否允许切换视角 */
    changeVisualAngleAble: { type: Boolean, default: true },
    /** 是否移除查询组件 */
    removeQuery: { type: Boolean, default: false },
    /** 是否移除视角 */
    removeVisualAngle: { type: Boolean, default: false },
    /** 是否移除倍速 */
    removeSpeed: { type: Boolean, default: false },
    /** 是否移除取消跟随按钮 */
    removeCancelFollow: { type: Boolean, default: false },
  },
  watch: {
    /** 监听历史轨迹加载状态并抛出 */
    loadHistoryTrial(val) {
      this.$emit('HistoryLoading', val)
    },
  },
  data() {
    return {
      /** 播放状态 */
      playStatus: false,
      /** 播放进度 */
      playProgress: 0,
      /** 加载数据 */
      loadSlider: false,
      /** 最大长度 */
      sliderMaxLength: 1,
      /** 进度条开始值 */
      sliderBegin: 0,
      /** 进度条结束值 */
      sliderEnd: 0,
      /** 当前人员视角, 默认第二人称视角 */
      visualAngle: 2,
      /** 当前支持的视角集合 */
      visualAngleList: Object.freeze([
        {
          value: 1,
          label: '第一人称视角',
        },
        {
          value: 2,
          label: '第二人称视角',
        },
        {
          value: 3,
          label: '称剖切视角',
        },
      ]),
      visualAngleOffset: {
        1: [0, -0.6, 2.3],
        2: [0, -1, 0.5],
        3: [0, 0, 1.6],
      },
      /** 播放速度 */
      speed: 0,
      /** 当前支持的播放速度列表 */
      speedList: [1, 2, 4, 8],
      /** 当前支持的播放速度列表 */
      speedOption: Object.freeze([
        {
          value: 0,
          label: '1X',
        },
        {
          value: 1,
          label: '2X',
        },
        {
          value: 2,
          label: '4X',
        },
        {
          value: 3,
          label: '8X',
        },
      ]),
      /** 当前回放的时间 */
      dateList: [],
      /** 历史轨迹id，为之后操作动画 */
      historicalTrajectoryId: '',
      /** 当前人员名称 */
      currentPersonName: '',
      /** 历史轨迹加载状态 */
      loadHistoryTrial: false,
      /** 进度条标记宽度 */
      sliderWidth: '6px',
      /** 进度条的标记  */
      sliderMarkerList: {},
      /** 忽略空数据粒度 */
      ignoreNull: 0,
      /** 历史轨迹真实结束时间  */
      trueEndTime: null,
      /** 是否跟随  */
      isFollow: true,
      pickerOptions: {
        cellClassName(date) {
          // 给日期上添加标记
          const markedDates = [];
          const dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
          if (markedDates.includes(dateString)) {
            return 'marked-date';
          }
          return '';
        }
      },
      buildingDetail: {},
      floorList: [],
      moveTimer: null,
      currentFloorId: '',
      oldFloorId: '',
      // 剖切区域的信息
      clipDetail: {},
      // 剖切类型
      clipType: {
        box: 0, // 盒子剖切
        singlePanel: 1, // 单面剖切
        doublePanel: 2, // 双面剖切
        ThreePanel: 3, // 三面剖切
      },
      // 打开剖切的方式
      clipDataType: {
        aabb: 0, // 包围盒
        model: 1, // 模型
        node: 2, // node
        item: 3,
        clipData: 4, // 剖切数据
      },
      isHide: false,
      // 组态数组
      configurationArr: [],
      // 传递的labelList
      propLabelList: [],
      // 最初的labelList
      oldLabelList: [],
      // 当前楼层的电子围栏数组
      currentFenceIdList: [],
      // 实时数据集合
      coordinateLocationList: [],
      // 能否调用筛选实时定位接口的标识
      flag: false,
      // 当前楼层
      nowFloor: '',
      personList: [],
      // 获取当前人员相关
      socketLineList: [],
      throttledGetFloorPersonTotal: null,
      socketManager: null,
      player: null,
      historyData: [],//历史轨迹数据
      historyDataGrouping: [],//历史轨迹数据根据楼层ID来分组轨迹时间
      historyTime: "",//当前播放的剖切视角历史时间
      beforeFloorID: "",//上次记录的楼层ID
      counter: 0,
    }
  },
  async created() {
    const socketEvent = new CustomEvent('operateSocket', {
      detail: {
        type: false,
      },
    })
    window.dispatchEvent(socketEvent)
    // 监听history变化
    const historicalTrajectoryEvent = new CustomEvent('HistoricalTrajectory', {
      detail: {
        isOpen: true,
      },
    })
    window.dispatchEvent(historicalTrajectoryEvent)
    this.cloudRender.Dispatch.on('HistoricalTrajectory', this.dealHistoricalTrajectory)
    this.getBuildingList()
  },
  computed: {
    buildingId() {
      // return this.transferProps.buildingId
      return ""
    },
  },
  mounted() {
    // 监听实时人员数据更新的事件
    window.addEventListener('setPositionList', this.positionListHandler)
  },
  watch: {
    // 如果人员id改变了
    personnelId: {
      immediate: true,
      async handler() {
        // 清除时间
        this.dateList = []
        this.sliderBegin = 0
        this.sliderEnd = 0
        this.sliderMarkerList = {}
        this.trueEndTime = null
        this.playStatus = false
        this.playProgress = 0
        this.speed = 0
        this.isFollow = true
        // 如果有历史轨迹，则清除
        await this.cloudRender.HistoricalTrajectory.destroy(this.historicalTrajectoryId)
        this.historicalTrajectoryId = ''
        await this.initData()
      },
    },
    labelList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.propLabelList = _.cloneDeep(value)
      },
    },
  },
  methods: {
    // 初始化数据
    async initData() {
      Object.keys(this.defaultData).forEach((key) => {
        if (key !== 'dateList') {
          this[key] = _.cloneDeep(this.defaultData[key])
        }
      })
      // 如果没有传递时间，则获取该标签最近一次有数据的时间
      if (_.isEmpty(this.defaultData.dateList)) {
        await this.getTagLastTime()
      } else {
        this.dateList = _.cloneDeep(this.defaultData.dateList)
      }
      if (!_.isEmpty(this.dateList)) {
        this.getHistoryTrialData()
        this.getMarkedDates()
      }
    },
    // 获取标签最后一次有数据的时刻
    async getTagLastTime() {
      const [err, res] = await personnelApi.getTagNewTime({
        tagIds: [this.tagCode],
      })
      if (!err) {
        if (!_.isEmpty(res)) {
          const newTime = _.get(_.head(res), 'newTime')
          if (newTime) {
            // this.dateList = [dayjs(newTime).subtract(2, 'hour').format('YYYY-MM-DD HH:mm:ss'), dayjs(newTime).format('YYYY-MM-DD HH:mm:ss')]
            this.dateList = [dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'), dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')]
          }
        } else {
          this.$emit('loadHistoryTrialEnd')
          return this.$message.warning({
            showClose: true,
            message: '暂无轨迹数据',
          })
        }
      }
    },
    /** 计算进度条的悬浮提示 */
    formatSliderTooltip() {
      return this.sliderBegin
        ? moment((moment(this.sliderBegin).unix() + this.playProgress) * 1000).format('HH:mm:ss')
        : '00:00:00'
    },
    /** 动画时间变化时 */
    async dealHistoricalTrajectory(data) {
      // console.log("data-----", data);
      if (data.historyId === this.historicalTrajectoryId) {
        this.playProgress = moment(data.time).diff(this.dateList[0]) / 1000
        /** 判断此刻是否有数据，若没有数据且超过允许空值则暂停 */
        const markerList = Object.keys(this.sliderMarkerList)
        const exist = markerList.includes(this.playProgress.toString())
        let isPlay = true
        if (!exist) {
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < markerList.length; i++) {
            if (Number(markerList[i]) > this.playProgress) {
              if (Number(markerList[i]) > this.playProgress + this.ignoreNull) {
                isPlay = false
                break

                // eslint-disable-next-line no-useless-return
              }
              isPlay = true
              break
            }
          }
        }
        this.historyDataGrouping.map(item => {
          if (!item.timePoints.includes(data.time)) {
            return
          } else {
            this.oldFloorId = item.floorId
          }
          if ((this.oldFloorId != this.currentFloorId) && this.counter == 0) {
            /** 如果有数据并且ID发生变化就触发切换剖切视角 */
            this.counter = 1
            this.historyTime = data.time
            this.visualAngle = 3
            console.log("data-----", data);
            this.changeVisualAngle()
          }
        })
        /** 如果播放到真实结束时间自动暂停 */
        const timeDiff = moment((moment(this.sliderBegin).unix() + this.playProgress) * 1000).diff(
          moment(this.trueEndTime)
        )
        if (timeDiff === 0) {
          isPlay = false
        }
        if (isPlay) return
        await this.cloudRender.HistoricalTrajectory.setStatus(this.historicalTrajectoryId, false)
        this.playStatus = false
        // console.log("监听历史轨迹播放进度",data);
      }
    },
    /** 进度条发生变化时 */
    async sliderChange(val) {
      const currentTime = moment(this.dateList[0])
        .add(this.playProgress * 1000)
        .format('YYYY-MM-DD HH:mm:ss')
      await this.cloudRender.HistoricalTrajectory.setTime(this.historicalTrajectoryId, currentTime)
    },
    /** 切换视角 */
    async changeVisualAngle() {
      // 如果是取消了跟随的就退出
      if (!this.isFollow) {
        await this.moveAngle(this.buildingDetail)
        this.outHandler()
        buildingList.display()
        await cloudRender.Clip.cancelClip(this.player)
        this.currentFloorId = ''
        return
      }
      console.log("this.player----", this.cloudRender.HistoricalTrajectory);
      this.player = this.cloudRender.HistoricalTrajectory.player

      if (this.visualAngle == 3) {
        let items = []
        if (this.historyTime) {
          items = this.historyData.filter(item => (!!item.floorInfo && (item.timePoint === this.historyTime)))
        }else{
          items = this.historyData
        }
        console.log('当前时间点的剖切数据', items)
        if(items.length === 0){
          this.counter = 0
          this.visualAngle == 2
          console.log("剖切时间与当前时间段不匹配");
          return
        }
        this.currentFloorId = items[0].floorInfo.id
        await this.cloudRender.HistoricalTrajectory.setPersonFollow(
          this.historicalTrajectoryId,
          this.currentPersonName,
          this.visualAngle,
          {
            targetPosOffset: this.visualAngleOffset[this.visualAngle],
            defaultOffset: 1,
          }
        )
        buildingList.hidden()
        this.goFloor(items[0].floorInfo)
      } else {
        this.oldFloorId = ""
        this.counter = 0
        buildingList.display()
        await cloudRender.Clip.cancelClip(this.player)
        this.currentFloorId = ''
        await this.cloudRender.HistoricalTrajectory.setPersonFollow(
          this.historicalTrajectoryId,
          this.currentPersonName,
          this.visualAngle,
          {
            targetPosOffset: this.visualAngleOffset[this.visualAngle],
            defaultOffset: this.visualAngle === 3 ? [0, 1, 0] : undefined,
          }
        )
      }
    },
    /** 查询历史轨迹 */
    async getHistoryTrialData() {
      this.historyId = ""
      const loadTrajectoryEvent = new CustomEvent('loadHistoryTrial')
      window.dispatchEvent(loadTrajectoryEvent)
      this.sliderWidth = '6px'
      if (this.dateList && this.dateList.length === 0 && !this.dateList[0] && !this.dateList[1]) {
        this.$message({
          message: '请选择时间',
          type: 'warning',
        })
        this.$emit('loadHistoryTrialEnd')
        return
      }
      this.loadHistoryTrial = true
      let query = {
        modelId: this.modelId,
        personnelId: this.personnelId,
        startTime: moment(this.dateList[0]).format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment(this.dateList[1]).format('YYYY-MM-DD HH:mm:ss'),
      }
      //变更日期时注意是否是选择当天时间
      if (query.startTime == query.endTime) {
        query.endTime = dayjs(query.startTime).add(1, 'day').format('YYYY-MM-DD HH:mm:ss')
        this.dateList = [
          query.startTime,
          new Date(query.endTime)
        ]
      }
      // 清空标记点
      this.sliderMarkerList = {}
      const [err, res] = await personnelApi.getPositionTrailList(
        query.personnelId,
        query.startTime,
        query.endTime,
        query.modelId,
        { isFloor: true },
      )
      if (!err) {
        if (res) {
          this.historyData = res.details
          if (this.historyData[0] && this.historyData[0].floorInfo) {
            //如果第一帧有楼层信息，则视角切换为刨切视角
            this.visualAngle = 3
          }
          this.historyDataGrouping = [];
          let tempIndex = -1
          let oldID = ""
          this.historyData.map(item => {
            if (item.floorInfo && (item.floorInfo.id != oldID)) {
              oldID = item.floorInfo.id
              tempIndex = tempIndex + 1
              this.historyDataGrouping.push({
                floorId: item.floorInfo.id,
                timePoints: [],
              })
            } else {
              this.historyDataGrouping[tempIndex] && this.historyDataGrouping[tempIndex].timePoints.push(item.timePoint)
            }
          })
          this.sliderBegin = moment(this.dateList[0]).format('YYYY-MM-DD HH:mm:ss')
          this.sliderEnd = moment(this.dateList[1]).format('YYYY-MM-DD HH:mm:ss')
          this.sliderMaxLength = moment(this.dateList[1]).diff(moment(this.dateList[0])) / 1000
          console.log("进度条最大值", this.sliderMaxLength);
          /** 计算进度条标记的宽度 */
          const width = (1 / (this.sliderMaxLength - 1)) * 100
          this.sliderWidth = width <= 0.0017 ? '0.0017%' : `${width}%`
          /** 如果已有历史轨迹则销毁 */
          if (this.historicalTrajectoryId) {
            await this.cloudRender.HistoricalTrajectory.destroy(this.historicalTrajectoryId)
            this.historicalTrajectoryId = ''
          }
          if (res.details.length === 0) {
            this.$message({
              message: '此时间段无历史数据',
              type: 'info',
            })
            this.loadHistoryTrial = false
            this.$emit('loadHistoryTrialEnd')
            return
          }
          this.trueEndTime = res.details[res.details.length - 1].timePoint
          await this.drawHistoryTrial(res)
        } else {
          this.$message({
            message: '此时间段无历史数据',
            type: 'info',
          })
          this.loadHistoryTrial = false
          this.$emit('loadHistoryTrialEnd')
          return
        }
      } else {
        this.sliderBegin = 0
        this.sliderEnd = 0
      }
      this.loadHistoryTrial = false
      this.changeStatus(false)
      this.$emit('loadHistoryTrialEnd')
    },
    /** 绘制历史轨迹 */
    async drawHistoryTrial(historyData) {
      console.log("绘制历史轨迹", historyData);
      const marks = {}
      const keyframeData = historyData.details.map((trialItem) => {
        /** 为有数据返回的数据添加标记 */
        if (moment(trialItem.timePoint).unix() !== moment(this.dateList[1]).unix()) {
          Object.assign(marks, {
            [moment(trialItem.timePoint).unix() - moment(this.dateList[0]).unix()]: '',
          })
        }
        return {
          time: moment(trialItem.timePoint).format('YYYY-MM-DD HH:mm:ss'),
          point: [trialItem.posX, trialItem.posY, trialItem.posZ],
        }
      })
      this.sliderMarkerList = marks
      console.log("this.sliderMarkerList", this.sliderMarkerList);
      const personHistoryData = [
        {
          name: historyData.personnelName,
          keyframeData: keyframeData,
        },
      ]
      const markerOption = {
        id: this.personnelId,
        pos: [0, 0, 0],
        background: 'sample',
        visible: true,
        nodeOffset: [0, 0],
        text: historyData.personnelName,
        textColor: '#ffff00ff',
        hasTriangle: true,
        markPosType: 4,
      }
      this.historicalTrajectoryId = this.generateUUID()
      const result = await this.cloudRender.HistoricalTrajectory.create(
        this.historicalTrajectoryId,
        personHistoryData,
        {
          personOption: {
            markerOption,
          },
        }
      )
      console.log("历史轨迹返回", result);
      await this.cloudRender.HistoricalTrajectory.setSpeed(
        this.historicalTrajectoryId,
        this.speedList[this.speed]
      )
      this.currentPersonName = historyData.personnelName
      // 跟随人员
      this.changeVisualAngle()
    },
    /** 修改状态 */
    async changeStatus(playStatus) {
      if (this.loadHistoryTrial) {
        return this.$message({
          message: '正在加载......,请稍后再试!',
          type: 'info',
        })
      }
      /** 判断此刻是否有数据如果没有数据则跳到下一时间段 */
      const markerList = Object.keys(this.sliderMarkerList)
      const exist = markerList.includes(this.playProgress.toString())
      if (!exist) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < markerList.length; i++) {
          if (Number(markerList[i]) > this.playProgress) {
            this.playProgress = Number(markerList[i])
            // eslint-disable-next-line no-useless-return
            break
          }
        }
        /** 跳转至有数据时间 */
        const currentTime = moment(this.dateList[0])
          .add(this.playProgress * 1000)
          .format('YYYY-MM-DD HH:mm:ss')
        await this.cloudRender.HistoricalTrajectory.setTime(
          this.historicalTrajectoryId,
          currentTime
        )
      }
      await this.cloudRender.HistoricalTrajectory.setStatus(this.historicalTrajectoryId, playStatus)
      this.playStatus = playStatus
    },
    /** 关闭历史轨迹 */
    async closeTrajectory() {
      await this.moveAngle(this.buildingDetail)
      // this.outHandler()
      buildingList.display()
      // 取消剖切效果并移动视角回到该建筑
      await cloudRender.Clip.cancelClip(this.player)
      this.currentFloorId = ''
      const socketEvent = new CustomEvent('operateSocket', {
        detail: {
          type: true,
        },
      })
      window.dispatchEvent(socketEvent)
      const historicalTrajectoryEvent = new CustomEvent('HistoricalTrajectory', {
        detail: {
          isOpen: false,
        },
      })
      window.dispatchEvent(historicalTrajectoryEvent)
      if (this.historicalTrajectoryId) {
        // 关闭历史轨迹
        await this.cloudRender.HistoricalTrajectory.destroy(this.historicalTrajectoryId)
        this.historicalTrajectoryId = ''
      }
      this.$emit('closeTrajectory')
    },
    /** 切换速度 */
    async changeSpeed(type) {
      if (type === 'add' && this.speed < 3) {
        this.speed += 1
      } else if (type === 'minus' && this.speed > 0) {
        this.speed -= 1
      }
      await this.cloudRender.HistoricalTrajectory.setSpeed(
        this.historicalTrajectoryId,
        this.speedList[this.speed]
      )
    },
    // 生成uuid
    generateUUID() {
      let d = new Date().getTime()
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now()
      }
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },
    /** 切换跟随 */
    async toggleFollow() {
      this.isFollow = !this.isFollow
      if (this.isFollow) {
        this.changeVisualAngle()
      } else {
        await this.cloudRender.HistoricalTrajectory.cancelPersonFollow()
        console.log("退出跟随时，重置视角");
      }
      //退出跟随时，重置视角
      // this.changeVisualAngle()
    },
    async getMarkedDates() {
      const query = {
        modelId: this.modelId,
        personnelId: this.personnelId,
        startTime: dayjs().subtract(1, 'year').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      }
      console.log("query----", query);
      const [err, res] = await personnelApi.judgeTimeSpanData(
        query.personnelId,
        query.startTime,
        query.endTime,
        query.modelId,
      )
      console.log("历史轨迹数据", res);
      let dateData = []
      res.map(item => {
        dateData.push(dayjs(item).format('YYYY-M-D'))
      })
      dateData = [...new Set(dateData)]
      console.log("dateData", dateData);
      this.$set(this.pickerOptions, 'cellClassName', (date) => {
        const markedDates = dateData;
        const dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        if (markedDates.includes(dateString)) {
          return 'marked-date';
        }
        return '';
      })
    },
    changeDateList(dateList) {
      console.log("修改时间", dateList);
      if (dateList[0].toString() == dateList[1].toString()) {
        dateList[1] = dayjs(dayjs(new Date(dateList[0])).format('YYYY-MM-DD HH:mm:ss')).endOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.dateList = [
          dateList[0],
          new Date(dateList[1])
        ]
      }
    },
    // 获取建筑列表
    async getBuildingList(sceneId) {
      const [err, res] = await buildingApi.getList({
        sceneId,
        skipCount: 0,
        maxResultCount: 1000,
      })
      this.buildingData = res.items
      console.log("获取建筑列表", this.buildingData);
    },
    // 获取建筑详情
    async getBuildingDetail() {
      const buildingId = "3a136ed2-6866-ad21-d029-f8380855c000"
      // const [err, res] = await buildingApi.get(this.transferProps.buildingId)
      const [err, res] = await buildingApi.get(buildingId)
      if (!err && !isEmpty(res)) {
        this.buildingDetail = res
      }
    },
    // 移动视角
    async moveAngle(data) {
      if (!isEmpty(data.angleJson)) {
        if (this.moveTimer) clearTimeout(this.moveTimer)
        this.moveTimer = setTimeout(async () => {
          cloudRender.Camera.moveCamera(this.player, 'CameraParam', data.angleJson)
          console.log("移动视角", JSON.parse(data.angleJson));
        }, 500)
      }
    },
    // 获取剖切区域的信息
    async getclipDetail(id) {
      const [err, res] = await clipApi.get(id)
      if (!err && !isEmpty(res)) {
        this.clipDetail = res
      }
    },
    // 进出楼层
    async goFloor(item) {
      console.log("进入了楼层", item);
      this.builDingNowId = item.buildingId
      this.currentFloorId = item.id
      this.beforeFloorID = item.id
      this.nowFloor = item.name
      // 已进入的时候把最初的labelList存下来
      this.oldLabelList = cloneDeep(this.propLabelList)
      // 获取包含在楼层中的围栏
      await this.getCurrentFloorFence()
      // 发射自定义事件筛选电子围栏显示
      const filterEvent = new CustomEvent('filterElectronicList', {
        detail: {
          filterElectronicIdList: this.currentFenceIdList,
        },
      })
      window.dispatchEvent(filterEvent)
      const disableEvent = new CustomEvent('setCheckDisable', {
        detail: {
          tagList: ['BuildingList'],
          disable: true,
        },
      })
      window.dispatchEvent(disableEvent)
      // 进入楼层其他标签的处理
      // this.inHandler()
      // 获取剖切参数
      await this.getclipDetail(item.sectionId)
      // 展示楼层剖切并进入视角
      await this.showArea()
      // await this.moveAngle(item)
      let angle = JSON.parse(item.angleJson)
      console.log("移动视角", angle);
      this.player.Native.Camera.addMoveTo(angle.eye, angle.target, angle.up, 1)
      this.counter = 0
    },
    // 展示剖切区域
    async showArea() {
      const min = cloneDeep(JSON.parse(this.clipDetail.minimumLocation))
      const max = cloneDeep(JSON.parse(this.clipDetail.maximumLocation))
      if (!isEmpty(min) && !isEmpty(max)) {
        const aabb = [
          [min.x, min.y, min.z],
          [max.x, max.y, max.z],
        ]
        // 通过包围盒的方式展示剖切盒子
        const res = await cloudRender.Clip.createCilp(this.player, this.clipDataType.aabb, this.clipType.box, {
          setIsInside: this.clipDetail.clipType === 0,
          setPartCilp: false,
          aabb,
        })
        // 监听剖切包围盒变化
        // cloudRender.Dispatch.on("Clip", (clipRes) => {
        //   console.log(clipRes, "剖切数据变化-------------");
        // });
        console.log(res, "全局剖切====================");
        console.log("显示剖切盒子信息", (this.player, this.clipDataType.aabb, this.clipType.box, {
          setIsInside: this.clipDetail.clipType === 0,
          setPartCilp: false,
          aabb,
        }));
        // 隐藏剖切轴和面
        await cloudRender.Clip.setVisible(this.player, 'Axis', false)
        await cloudRender.Clip.setVisible(this.player, 'Panel', false)
      }
    },
    // 切换是否隐藏按钮
    async toggleHide() {
      // 如果绑定了组态（只关心隐藏，添加组态时已经筛选）
      const that = this
      if (!isEmpty(this.buildingDetail.configurationId)) {
        this.isHide = !this.isHide
        if (this.isHide) {
          // 隐藏组态
          const [err, hiddenArr] = await compositeStateApi.getNeedHiddenDetails(
            this.buildingDetail.configurationId
          )
          if (!err && !isEmpty(hiddenArr)) {
            this.configurationArr = await Promise.all(
              map(hiddenArr, async (item) => {
                const info = await that.player.Native.ModelTree.findItemByName(
                  item.modelName,
                  0,
                  true,
                  3
                )
                if (!isEmpty(info)) {
                  return info.item
                }
              })
            )
            // 设置组态隐藏
            await this.setVisible(false)
          }
        } else {
          // 取消隐藏
          await this.setVisible(true)
        }
      } else {
        this.$message.warning({
          shwoClose: true,
          message: '该建筑未关联组态',
        })
      }
    },
    // 设置组态显隐
    async setVisible(type) {
      for (let i = 0; i < this.configurationArr.length; i++) {
        await cloudRender.Node.setItemStatus(this.player, this.configurationArr[i], type)
      }
    },
    // 接受到实时定位数据的处理（发送请求筛选楼层中的人员）
    async positionListHandler(e) {
      // 如果进入楼层了才开始计算
      if (!isEmpty(e?.detail?.position) && !isEmpty(this.currentFloorId)) {
        this.coordinateLocationList = cloneDeep(e.detail.position)
        this.flag = true
        await this.getCurrentFloorTag()
      }
    },
    // 进入楼层后获取在当前楼层的电子围栏
    async getCurrentFloorFence() {
      // 获取到围栏id后发送事件
      const [err, res] = await floorApi.getFloorAllFences({
        floorIds: [this.currentFloorId],
        modelId: this.customProps?.sceneId,
      })
      if (!err && !isNil(res)) {
        this.currentFenceIdList = map(res, (item) => {
          return item.fenceId
        })
      }
    },
    // 进入楼层其他标签的变化
    inHandler() {
      // 只显示人员和电子围栏
      const newLabelList = map(this.oldLabelList, (item) => {
        // 如果一进来电子围栏和人员标签是打开的，则不要关闭
        if ((item.code === 'ElectronicFence' || item.code === 'PersonnelList') && item.checked) {
          return {
            ...item,
            checked: true,
          }
        }
        return {
          ...item,
          checked: false,
        }
      })
      const hiddenList = filter(this.oldLabelList, (item) => {
        return item.checked
      })
      const hiddenEvent = new CustomEvent('setComponentVisible', {
        detail: {
          type: 'hidden',
          hiddenList,
          newLabelList,
        },
      })
      window.dispatchEvent(hiddenEvent)
    },
    // 退出楼层其他标签的变化
    outHandler() {
      // 获取目前已经打开的标签数组（除了围栏和人员）
      const openCodeList = map(
        filter(this.propLabelList, (item) => {
          return item.checked
        }),
        (i) => {
          return i.code
        }
      )
      // 对比目前已经打开和进入楼层时打开的标签
      // 得到需要重新打开的标签的数组
      const displayLabelList = filter(this.oldLabelList, (item) => {
        // 在进入后被关闭的标签需要重新显示
        if (
          !some(openCodeList, (i) => {
            return i === item.code
          }) &&
          item.checked
        ) {
          return true
        }
        if (
          // 电子围栏或者人员再打开的则也需要取消筛选功能
          some(openCodeList, (i) => {
            return i === item.code
          }) &&
          (item.code === 'ElectronicFence' || item.code === 'PersonnelList')
        ) {
          return true
        }
      })
      // 得到当前应该还原的labelList，给labelList重新赋值
      const newLabelList = map(this.oldLabelList, (item) => {
        // 进入楼层之后手动打开的和进入楼层时就是打开的
        if (
          some(openCodeList, (i) => {
            return i === item.code
          }) ||
          item.checked
        ) {
          return {
            ...item,
            checked: true,
          }
        }
        return {
          ...item,
          checked: false,
        }
      })
      const displayEvent = new CustomEvent('setComponentVisible', {
        detail: {
          type: 'display',
          displayLabelList,
          newLabelList,
        },
      })
      window.dispatchEvent(displayEvent)
    },
  },
  async beforeDestroy() {
    await this.closeTrajectory()
    // 解绑事件
    window.removeEventListener('setPositionList', this.positionListHandler)
    if (this.moveTimer) {
      clearTimeout(this.moveTimer)
      this.moveTimer = null
    }
    // 如果进入楼层了
    if (!isEmpty(this.currentFloorId)) {
      this.outHandler()
    }
    // 取消剖切
    cloudRender.Clip.cancelClip(this.player)
    // 清理资源
    if (this.throttledGetFloorPersonTotal?.cancel) {
      this.throttledGetFloorPersonTotal.cancel()
    }
    this.socketManager.disconnect()
  },
}
</script>
<style lang="scss">
@import '../../../assets/styles/select.scss';
</style>
<style lang="scss" scoped>
.trajectory {
  border-radius: 4px;
  background: linear-gradient(158.1deg, #0b232e 37.5%, #13455e 101.79%),
    linear-gradient(154.36deg, #77daff 3.57%, rgba(52, 185, 242, 0.4) 90.08%);

  .animate-control {
    border-radius: 50%;
    background: #134860;
  }

  .cancelBtn {
    width: 80px !important;
  }
}
::v-deep .el-slider__stop {
  position: absolute;
  height: 6px;
  width: var(--width);
  border-radius: 0;
  background-color: #15cea0;
  z-index: 2;
  -webkit-transform: none;
  -ms-transform: none;
  transform: none;
}
// 可视化input
::v-deep .el-input__inner {
  border: 1px solid #d1e6ff4d !important;
  border-radius: 4px !important;
  background: transparent !important;
  font-size: 14px !important;
  color: #fff !important;
}
::v-deep.el-date-editor .el-range-input {
  background: transparent !important;
  color: #fff !important;
}
::v-deep.el-slider__runway {
  background-color: #134860 !important;
  height: 4px !important;
  margin: 5px 0 !important;

  .el-slider__button {
    width: 8px !important;
    height: 8px !important;
    border: 1px solid #03ffec !important;
  }
}
::v-deep.el-button {
  background: linear-gradient(170.88deg,
      rgba(5, 240, 255, 0.0001) 37.75%,
      rgba(59, 255, 245, 0.4) 82.46%),
    linear-gradient(180deg, rgba(6, 240, 255, 0.12) 0.44%, rgba(9, 247, 247, 0.24) 100%) !important;
  box-shadow: 0px 2px 7px rgba(0, 100, 132, 0.3), inset 0px 1px 15px rgba(20, 199, 238, 0.2) !important;
  border-radius: 4px !important;
  border: #29bab1 !important;
  width: 70px !important;
}
::v-deep .el-slider__bar {
  background-color: #feff00 !important;
  z-index: 5;
}
::v-deep.el-slider__button {
  border: 2px solid #feff00;
}
::v-deep.el-date-editor .el-range-separator {
  background: transparent !important;
  color: #434343 !important;
}
::v-deep.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 390px !important;
}
.single-close {
  background: linear-gradient(146.24deg, #114e67, #0a364d),
    radial-gradient(circle at 50% 50%, #59c8fc 0, rgba(82, 172, 229, 0) 100%);
  border: 1px solid #34b9f2;
}
</style>
